// Builds a CSV (one checklist per row) from full checklist documents.
// Column layout comes from checklistColumns so it stays in sync with the
// spreadsheet export.

import { CHECKLIST_HEADERS, flattenChecklist } from "@ambulance/shared";

// UTF-8 byte order mark — makes Excel detect UTF-8 (correct Arabic/special chars).
const BOM = "﻿";

function csvCell(value: string): string {
  const s = String(value ?? "");
  return /[",\n\r]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
}

// Generic CSV builder (header row + data rows), with the same Excel-friendly
// BOM + CRLF + quoting as the checklist export. Used for the users export.
export function rowsToCsv(headers: string[], rows: string[][]): string {
  const lines: string[] = [headers.map(csvCell).join(",")];
  for (const r of rows) lines.push(r.map(csvCell).join(","));
  return BOM + lines.join("\r\n");
}

export function checklistsToCsv(rows: any[]): string {
  const lines: string[] = [CHECKLIST_HEADERS.map(csvCell).join(",")];
  for (const c of rows) {
    lines.push(flattenChecklist(c).map(csvCell).join(","));
  }
  // BOM for Excel UTF-8 detection; CRLF line endings for Excel compatibility.
  return BOM + lines.join("\r\n");
}

export function downloadCsv(filename: string, csv: string) {
  const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}
